import algoliasearch, { SearchClient } from "algoliasearch";
import { useLanguage } from "src/utils/localization/languages/I18nContext";
import useMapQueryStringSearch from "./useMapQueryStringSearch";
import useSearchAnalytics from "./useSearchAnalytics";
import FYCQueryBuilder, { FYCQuery } from "./FYCQueryBuilder";
import { SearchState } from "react-instantsearch-core";
import { Currency } from "src/utils/localization/currency";

export type UseFYCReturnValues = {
  searchClient: SearchClient;
  filterDefaultSearch: FYCQuery;
  searchState: SearchState;
  createURL: (searchState: SearchState) => string;
  onSearchStateChange: (
    updatedSearchState: SearchState,
    searchState: SearchState
  ) => void;
  localizedSearchIndexName: string;
  triggerSearch: (updatedSearchState: SearchState) => void;
};

const searchClient = algoliasearch(
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  process.env.GATSBY_ALGOLIA_APP_ID!,
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  process.env.GATSBY_ALGOLIA_API_KEY!
);
const defaultSearchIndexName = `${process.env.GATSBY_ALGOLIA_ENV}_cruises`;

export function useFYC(
  initialQuery: FYCQuery | undefined,
  currentCurrency: Currency,
  updateQueryString = true
): UseFYCReturnValues {
  const language = useLanguage();
  const localizedSearchIndexName = `${defaultSearchIndexName}_${language.code}`;

  const {
    onSearchStateChange: analyticsOnSearchStateChange
  } = useSearchAnalytics("cruise-filters-changed", undefined);

  const {
    searchState,
    triggerSearch,
    onSearchStateChange,
    createURL
  } = useMapQueryStringSearch(analyticsOnSearchStateChange, updateQueryString);

  const queryBuilder = new FYCQueryBuilder(initialQuery);
  queryBuilder.onlyFutureCruises().onlyVisibleForCurrency(currentCurrency);

  if (process.env.GATSBY_SHOW_ALL_FUTURE_CRUISES != "true")
    queryBuilder.onlyVisibleCruises();

  const filterDefaultSearch = queryBuilder.generate();

  return {
    searchClient,
    filterDefaultSearch,
    searchState,
    createURL,
    onSearchStateChange,
    triggerSearch,
    localizedSearchIndexName
  };
}
